module.exports = __webpack_public_path__ + "img/wave.ad6ef802.png";